import { combineReducers } from "redux";

import resetUI from "../core/reset/reducer/reset.reducer";

export default () =>
  combineReducers({
    ui: combineReducers({
      reset: resetUI(),
    }),
  });
